import { useState, useEffect } from 'react'
import style from './style'
import Text from './text.json'
import { createUseStyles } from 'react-jss'
import {
  TypographyElement,
  Icon,
  Icons
} from 'UI'
import SavedCard from './savedCard'
import CreditCardForm from '../CreditCardForm'
import { carteInternational, paypalIcon, paypalLogo, carteNationale, visaIcon, mastercardIcon } from 'assets'
import { useLocation } from 'react-router-dom'
import CreditCmiCardForm from '../CreditCmiCardForm'
import { morrocanCurrency } from 'store/currency'
import { splitPayments } from 'helpers'
import { morrocoShopId } from 'constants/'

export const cardTypes = {
  paypal: 'paypal',
  cb: 'cb',
  cmi: 'cmi',
  bp: 'bp'
}

export default ({
  addCreditCard,
  cards,
  addPaypalAccount,
  fetchCards,
  cartMode,
  changeDefaultPaymentMethodAction,
  deleteCard,
  deletePaypal,
  addingCreditCard,
  currency,
  shopId,
  profilePayment
}) => {
  useEffect(() => { !cartMode && fetchCards() }, [])

  const [cmiPaymentMethod, otherPaymentMethods] = splitPayments(cards)
  const [currentCards, setCurrentCards] = useState(profilePayment ? cards : otherPaymentMethods)

  useEffect(() => {
    if (profilePayment) {
      setCurrentCards(cards)
    } else if (currency === morrocanCurrency) {
      setCurrentCards(cmiPaymentMethod)
    } else {
      setCurrentCards(otherPaymentMethods)
    }
  }, [currency, cards])

  const { pathname } = useLocation()
  const useStyles = createUseStyles(style)
  const [visibleForm, setVisibleForm] = useState({ type: cardTypes.cb, open: true })
  const {
    paypallRoot,
    paypallIcon,
    row,
    creditCardRoot,
    creditCardIcon,
    newCardInfos,
    addCard,
    paypalGroup,
    paypalLogoClass,
    paypalLink,
    arrowIcon,
    addPaypal,
    addCardCmi
  } = useStyles({ visibleForm })
  return (
    <div>
      {currentCards.map(card => <SavedCard key={card.Id} card={card} changeDefaultPaymentMethodAction={changeDefaultPaymentMethodAction} deleteCard={deleteCard} deletePaypal={deletePaypal} />)}
      {
        shopId !== morrocoShopId
          ? (
            <>
              <div className={creditCardRoot}>
                <div className={addCard} onClick={() => setVisibleForm({ type: cardTypes.cb, open: visibleForm.type !== cardTypes.cb ? true : !visibleForm.open })}>
                  <div className={row}>
                    <img src={visaIcon} className={creditCardIcon} />
                    <img src={mastercardIcon} className={creditCardIcon} />
                  </div>
                  <Icon iconName={(visibleForm.type === cardTypes.cb && visibleForm.open) ? Icons.roundedDown : Icons.roundedUp} style={arrowIcon} />
                </div>
                {
                  visibleForm.type === cardTypes.cb && visibleForm.open &&
                    <div className={newCardInfos}>
                      <CreditCardForm
                        addingCreditCard={addingCreditCard}
                        addCreditCard={addCreditCard}
                        closeForm={() =>
                          setVisibleForm({
                            type: cardTypes.cb,
                            open: visibleForm.type !== cardTypes.cb ? true : !visibleForm.open
                          })}
                      />
                    </div>
                }
              </div>
              <div>
                <div className={addPaypal} onClick={() => setVisibleForm({ type: cardTypes.paypal, open: visibleForm.type !== cardTypes.paypal ? true : !visibleForm.open })}>
                  <div className={paypallRoot}>
                    <img src={paypalIcon} className={paypallIcon} />
                  </div>
                  <Icon iconName={(visibleForm.type === cardTypes.paypal && visibleForm.open) ? Icons.roundedDown : Icons.roundedUp} style={arrowIcon} />
                </div>
                {
                  visibleForm.type === cardTypes.paypal && visibleForm.open &&
                    <div className={paypalGroup}>
                      <TypographyElement
                        variant='body1'
                        margin='0 0 16px 0'
                      >
                        {Text.connectWithPaypal}
                      </TypographyElement>
                      <div className={paypalLink} onClick={() => addPaypalAccount(pathname)}>
                        <img src={paypalLogo} className={paypalLogoClass} />
                      </div>
                    </div>
                }
              </div>
            </>)
          : (
            <>
              {
                (currency !== morrocanCurrency || profilePayment) && (
                  <>
                    <div className={creditCardRoot}>
                      <div className={addCard} onClick={() => setVisibleForm({ type: cardTypes.cb, open: visibleForm.type !== cardTypes.cb ? true : !visibleForm.open })}>
                        <div className={row}>
                          <img src={carteInternational} className={creditCardIcon} />
                          <TypographyElement variant='body2'>
                            {Text.internationalTitle}
                          </TypographyElement>
                        </div>
                        <Icon iconName={(visibleForm.type === cardTypes.cb && visibleForm.open) ? Icons.roundedDown : Icons.roundedUp} style={arrowIcon} />
                      </div>
                      {
                        visibleForm.type === cardTypes.cb && visibleForm.open &&
                          <div className={newCardInfos}>
                            <CreditCardForm addingCreditCard={addingCreditCard} addCreditCard={addCreditCard} closeForm={() => setVisibleForm({ type: cardTypes.cb, open: visibleForm.type !== cardTypes.cb ? true : !visibleForm.open })} />
                          </div>
                      }
                    </div>
                    <div>
                      <div className={addPaypal} onClick={() => setVisibleForm({ type: cardTypes.paypal, open: visibleForm.type !== cardTypes.paypal ? true : !visibleForm.open })}>
                        <div className={paypallRoot}>
                          <img src={paypalIcon} className={paypallIcon} />
                        </div>
                        <Icon iconName={(visibleForm.type === cardTypes.paypal && visibleForm.open) ? Icons.roundedDown : Icons.roundedUp} style={arrowIcon} />
                      </div>
                      {
                        visibleForm.type === cardTypes.paypal && visibleForm.open &&
                          <div className={paypalGroup}>
                            <TypographyElement
                              variant='body1'
                              margin='0 0 16px 0'
                            >
                              {Text.connectWithPaypal}
                            </TypographyElement>
                            <div className={paypalLink} onClick={() => addPaypalAccount(pathname)}>
                              <img src={paypalLogo} className={paypalLogoClass} />
                            </div>
                          </div>
                      }
                    </div>
                  </>
                )
              }
              {(currency === morrocanCurrency || profilePayment) && (
                <>
                  <div className={creditCardRoot}>
                    <div className={addCardCmi} onClick={() => setVisibleForm({ type: cardTypes.cmi, open: visibleForm.type === cardTypes.cmi ? !visibleForm.open : true })}>
                      <div className={row}>
                        <img src={carteNationale} className={creditCardIcon} />
                        <TypographyElement variant='body2'>
                          {Text.cmiTitle}
                        </TypographyElement>
                      </div>
                      <Icon iconName={(visibleForm.type === cardTypes.cmi && visibleForm.open) ? Icons.roundedDown : Icons.roundedUp} style={arrowIcon} />
                    </div>
                    {
                      visibleForm.type === cardTypes.cmi && visibleForm.open &&
                        <div className={paypalGroup}>
                          <CreditCmiCardForm addingCreditCard={addingCreditCard} />
                        </div>
                    }
                  </div>
                </>
              )}
            </>
            )
      }
    </div>
  )
}
